import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack, Text } from '@nike/podium';
/**
 * Displays a team member with their role, name, and optional email.
 * Used consistently across Expression and Project detail views.
 *
 * @param role - The team member's role (e.g., 'Developer', 'PLM')
 * @param name - The team member's display name
 * @param email - Optional email or user identifier
 * @param variant - Display style: 'card' (with background) or 'inline' (text only)
 */
export function TeamMemberCard({ role, name, email, variant = 'card' }) {
    if (!name)
        return null;
    if (variant === 'inline') {
        return (_jsxs(Text, { font: "body-2", className: "pds-color-text-secondary", children: [name, " - ", role] }));
    }
    return (_jsxs(Stack, { gap: "xs", className: "p-4 bg-muted rounded-lg", children: [_jsx(Text, { font: "body-2-strong", children: role }), _jsx(Text, { font: "body-2", className: "pds-color-text-secondary", children: name }), email && (_jsx(Text, { font: "body-3", className: "pds-color-text-secondary", children: email }))] }));
}
